import NavLinkAdapter from '@fuse/core/NavLinkAdapter';
import ListSubheader from '@mui/material/ListSubheader';
import { makeStyles } from '@mui/styles';
import { alpha } from '@mui/material/styles';
import clsx from 'clsx';
import { useMemo } from 'react';
import FuseNavItem from '../../FuseNavItem';

// Group/section header del sidebar: tipografía cyan tenue alineada con el wizard.
const useStyles = makeStyles(theme => ({
	item: props => ({
		height: 32,
		width: '100%',
		margin: '20px 0 6px 0',
		paddingRight: 12,
		paddingLeft: props.itemPadding > 80 ? 80 : props.itemPadding,
		color: alpha('#38BDF8', 0.85),
		fontWeight: 700,
		letterSpacing: '0.08em',
		textTransform: 'uppercase'
	})
}));

function FuseNavVerticalGroup(props) {
	const { item, nestedLevel, onItemClick } = props;
	const classes = useStyles({
		itemPadding: nestedLevel > 0 ? 28 + nestedLevel * 16 : 12
	});

	return useMemo(
		() => (
			<>
				<ListSubheader
					disableSticky
					className={clsx(
						classes.item,
						'fuse-list-subheader flex items-center',
						!item.url && 'cursor-default'
					)}
					onClick={() => onItemClick?.(item)}
					component={item.url ? NavLinkAdapter : 'li'}
					to={item.url}
				>
					<span className="fuse-list-subheader-text uppercase text-12">{item.title}</span>
				</ListSubheader>

				{item.children && (
					<>
						{item.children.map(_item => (
							<FuseNavItem
								key={_item.id}
								type={`vertical-${_item.type}`}
								item={_item}
								nestedLevel={nestedLevel}
								onItemClick={onItemClick}
							/>
						))}
					</>
				)}
			</>
		),
		[classes.item, item, nestedLevel, onItemClick]
	);
}

const NavVerticalGroup = FuseNavVerticalGroup;

export default NavVerticalGroup;
